import React from 'react';
import { FiSearch, FiChevronDown } from 'react-icons/fi';

const ProductSearchInput = ({
  value = '',
  onSearchChange,
  onNavigateResults,
  inputRef,
  onHideKeyboard,
}) => {
  return (
    <div className="relative">
      <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
      <input
        type="text"
        placeholder="Search products by name or SKU..."
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        value={value}
        ref={inputRef}
        onChange={(e) => onSearchChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            e.stopPropagation();
            onNavigateResults?.(e);
          } else if (e.key === 'Enter') {
            // Allow Enter to bubble so scanners that send Enter can still trigger barcode hooks.
            e.preventDefault();
            onNavigateResults?.(e);
          }
        }}
      />
      {onHideKeyboard && (
        <button
          type="button"
          aria-label="Hide keyboard"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700 bg-slate-100 rounded-full p-1"
          onClick={() => {
            inputRef?.current?.blur();
            onHideKeyboard?.();
          }}
        >
          <FiChevronDown />
        </button>
      )}
    </div>
  );
};

export default ProductSearchInput;
